export const formatNumber = (num: number): string => {
  const [int, dec] = `${Number.parseFloat(num.toFixed(2))}`.split('.');
  const formattedInt = int.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

  return dec ? `${formattedInt},${dec}` : formattedInt;
};

export function formatSmallNumber(value: number) {
  if (Math.abs(value) >= 0.01) {
    return value;
  }

  let sign = value < 0 ? '-' : '';

  let absValue = Math.abs(value);

  let valueStr = absValue.toFixed(20);

  let zeros = 0;

  for (let i = 2; i < valueStr.length; i++) {
    if (valueStr[i] === '0') {
      zeros++;
    } else if (valueStr[i] !== '.') {
      break;
    }
  }

  let significantDigits = valueStr.slice(zeros + 2, zeros + 4);

  let formattedNumber = `${sign}0.0(${zeros})${significantDigits}`;

  return formattedNumber;
}

export function formatDollarAmount(
  amount = 0,
  minimumFractionDigits = 2,
  maximumFractionDigits = 2,
  ignoreSmallValue?: boolean,
) {
  if (!ignoreSmallValue && Math.abs(amount) < 0.01 && Math.abs(amount) !== 0) {
    return `$${formatSmallNumber(Number(amount))}`;
  }

  const formattedAmount = amount?.toLocaleString('en-US', {
    minimumFractionDigits,
    maximumFractionDigits,
  });

  return '$' + formattedAmount;
}
